import { normalColor } from './base'

export const inputHeightBase = '42px'
export const inputHeightLg = '50px'
export const inputHeightSm = '34px'
export const inputHoverBorderColor = normalColor
